import React from "react";
import Home from "./containers/Home";
import "./assets/css/global.scss";

function App() {
  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;
